// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: rfBwk6gUdaaYXmMwm7dJro
// Component: gLl-qQxP68
import * as React from "react";

import * as p from "@plasmicapp/react-web";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import UseCaseCard from "../../UseCaseCard"; // plasmic-import: Fd6NMAsUdX/component

import { useScreenVariants as useScreenVariants_34UUxzC7U7Qo } from "../simple_light_landing_page/PlasmicGlobalVariant__Screen"; // plasmic-import: 34UUxzC7U7Qo/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../simple_light_landing_page/plasmic_simple_light_landing_page.module.css"; // plasmic-import: rfBwk6gUdaaYXmMwm7dJro/projectcss
import sty from "./PlasmicUseCases.module.css"; // plasmic-import: gLl-qQxP68/css

import CodeIcon from "./icons/PlasmicIcon__Code"; // plasmic-import: P1WWHCJ58/icon
import ProductIcon from "./icons/PlasmicIcon__Product"; // plasmic-import: Q-1DPpL8_/icon
import MachinelearningIcon from "./icons/PlasmicIcon__Machinelearning"; // plasmic-import: -1cbwUAKs/icon

export type PlasmicUseCases__VariantMembers = {};

export type PlasmicUseCases__VariantsArgs = {};
type VariantPropType = keyof PlasmicUseCases__VariantsArgs;
export const PlasmicUseCases__VariantProps = new Array<VariantPropType>();

export type PlasmicUseCases__ArgsType = {};
type ArgPropType = keyof PlasmicUseCases__ArgsType;
export const PlasmicUseCases__ArgProps = new Array<ArgPropType>();

export type PlasmicUseCases__OverridesType = {
  root?: p.Flex<"div">;
  title?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultUseCasesProps {
  className?: string;
}

function PlasmicUseCases__RenderFunc(props: {
  variants: PlasmicUseCases__VariantsArgs;
  args: PlasmicUseCases__ArgsType;
  overrides: PlasmicUseCases__OverridesType;
  dataFetches?: PlasmicUseCases__Fetches;
  forNode?: string;
}) {
  const { variants, args, overrides, forNode, dataFetches } = props;

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariants_34UUxzC7U7Qo()
  });

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(projectcss.all, projectcss.root_reset, sty.root)}
    >
      <div
        data-plasmic-name={"title"}
        data-plasmic-override={overrides.title}
        className={classNames(projectcss.all, projectcss.__wab_text, sty.title)}
      >
        {"Designed for you"}
      </div>

      <p.Stack
        as={"div"}
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <UseCaseCard
          body={
            "Eliminate repetitive test code.\nUtilize dynamic, data-driven tests.\nReduce triage and debugging time."
          }
          icon={
            <CodeIcon
              className={classNames(projectcss.all, sty.svg__cTzAq)}
              role={"img"}
            />
          }
          title={"Developers"}
        />

        <UseCaseCard
          body={
            "Automate acceptance testing.\nIncrease data quality transparency.\nImprove developer collaboration."
          }
          className={classNames("__wab_instance", sty.useCaseCard__aTfgk)}
          icon={
            <ProductIcon
              className={classNames(projectcss.all, sty.svg__dWr2)}
              role={"img"}
            />
          }
          title={"Product Managers"}
        />

        <UseCaseCard
          body={
            "Centralize data testing criteria.\nEliminate data inconsistencies.\nAchieve full business coverage."
          }
          className={classNames("__wab_instance", sty.useCaseCard__geM5)}
          icon={
            <MachinelearningIcon
              className={classNames(projectcss.all, sty.svg__zJ0Jb)}
              role={"img"}
            />
          }
          title={"Business Analysts"}
        />
      </p.Stack>
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "title", "freeBox"],
  title: ["title"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  title: "div";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicUseCases__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicUseCases__VariantsArgs;
    args?: PlasmicUseCases__ArgsType;
    overrides?: NodeOverridesType<T>;
    dataFetches?: PlasmicUseCases__Fetches;
  } & Omit<PlasmicUseCases__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicUseCases__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicUseCases__ArgProps,
      internalVariantPropNames: PlasmicUseCases__VariantProps
    });

    const { dataFetches } = props;

    return PlasmicUseCases__RenderFunc({
      variants,
      args,
      overrides,
      dataFetches,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicUseCases";
  } else {
    func.displayName = `PlasmicUseCases.${nodeName}`;
  }
  return func;
}

export const PlasmicUseCases = Object.assign(
  // Top-level PlasmicUseCases renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    title: makeNodeComponent("title"),
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicUseCases
    internalVariantProps: PlasmicUseCases__VariantProps,
    internalArgProps: PlasmicUseCases__ArgProps
  }
);

export default PlasmicUseCases;
/* prettier-ignore-end */
